// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__oT8_4","title":"styles_title__HR4zB","subTitle":"styles_subTitle__agv2O","buttonBox":"styles_buttonBox__djM_I","button":"styles_button__O065w"};